import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import BrandsIndex from "@/pages/BrandsIndex";
import QRMenu from "@/pages/QRMenu";
import Kiosk from "@/pages/Kiosk";
import HubLogin from "@/pages/HubLogin";
import Hub from "@/pages/Hub";
import Counter from "@/pages/Counter";
import TrackBoard from "@/pages/TrackBoard";
import KioskSetup from "@/pages/KioskSetup";
import OrderConfirmation from "@/pages/OrderConfirmation";
import PrintSlips from "@/pages/PrintSlips";
import HubPrintStation from "@/pages/HubPrintStation";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBrandEditor from "@/pages/admin/AdminBrandEditor";
import AdminBusinessSettings from "@/pages/admin/AdminBusinessSettings";
import OrderSuccess from "@/pages/OrderSuccess";
import MultiBrandOrder from "@/pages/MultiBrandOrder";
import { AdminAuthProvider } from "@/lib/adminAuth";
import { AdminProtected } from "@/pages/admin/AdminShell";
import { InstallPWAPrompt } from "@/components/InstallPWAPrompt";

function App() {
    return (
        <AdminAuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* Root — customers landing on the bare domain go straight
                        to the multi-brand ordering surface (per owner req). */}
                    <Route path="/" element={<Navigate to="/order" replace />} />
                    <Route path="/landing" element={<Landing />} />
                    <Route path="/brands" element={<BrandsIndex />} />
                    <Route path="/m/:slug" element={<QRMenu />} />
                    <Route path="/order" element={<MultiBrandOrder />} />
                    <Route path="/kiosk" element={<Kiosk />} />
                    <Route path="/kiosk/setup" element={<KioskSetup />} />
                    <Route path="/kiosk-setup" element={<KioskSetup />} />
                    <Route path="/hub/login" element={<HubLogin />} />
                    <Route path="/hub" element={<Hub />} />
                    <Route path="/hub/print-station" element={<HubPrintStation />} />
                    <Route path="/counter" element={<Counter />} />
                    <Route path="/order/:id" element={<OrderConfirmation />} />
                    <Route path="/track" element={<TrackBoard />} />
                    <Route path="/order-success" element={<OrderSuccess />} />
                    <Route path="/print/:id" element={<PrintSlips />} />
                    {/* Admin */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={<AdminProtected><AdminDashboard /></AdminProtected>}
                    />
                    <Route
                        path="/admin/brand/:id"
                        element={<AdminProtected><AdminBrandEditor /></AdminProtected>}
                    />
                    <Route
                        path="/admin/settings"
                        element={<AdminProtected><AdminBusinessSettings /></AdminProtected>}
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <InstallPWAPrompt />
            </BrowserRouter>
        </AdminAuthProvider>
    );
}

export default App;
